import clsx from 'clsx';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from '@sportsbook/common/components/button/button';

import './footer-see-more-button.scss';

export function FooterSeeMoreButton({ isExpanded, onClick }) {
  return (
    <Button className={clsx('sb-FooterSeeMoreButton', { isExpanded })} onClick={onClick}>
      <FormattedMessage id={isExpanded ? 'footer.see-less' : 'footer.see-more'} />
    </Button>
  );
}

FooterSeeMoreButton.propTypes = {
  isExpanded: PropTypes.bool.isRequired,
  onClick: PropTypes.func.isRequired,
};
